import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import {
  CardContainer,
  CardHeader,
  CardTitle,
  CardBody,
  CardContent,
  CardAccordionWrapper,
  CardAccordionContent,
} from './styles'
import { AccordionButton } from '../CheckBox/style'

const InformationCard = ({
  title,
  content,
  accordionHint,
  accordionContent,
}) => {
  const [openAccordion, setOpenAccordion] = useState(false)
  const accordionText = useRef(null)
  function toggleAccordion() {
    setOpenAccordion(!openAccordion)
    if (!openAccordion) {
      setTimeout(() => accordionText.current.focus(), 300)
    }
  }

  return (
    <CardContainer>
      <CardHeader>
        <CardTitle id={title}>{title}</CardTitle>
      </CardHeader>
      <CardBody>
        {content.map((item, index) => (
          <CardContent key={index}>{item}</CardContent>
        ))}

        {accordionContent && (
          <CardAccordionWrapper role="accordion">
            <CardAccordionContent
              aria-hidden={!openAccordion}
              id="accordion-content"
              ref={accordionText}
              tabIndex="0"
            >
              {accordionContent}
            </CardAccordionContent>
            <AccordionButton
              onClick={() => toggleAccordion()}
              aria-expanded={openAccordion}
              aria-controls="accordion-content"
              aria-labelledby={title}
              aria-describedby={`see more about ${title}`}
            >
              {openAccordion
                ? 'See less'
                : accordionHint
                ? accordionHint
                : 'See more'}
            </AccordionButton>
          </CardAccordionWrapper>
        )}
      </CardBody>
    </CardContainer>
  )
}
// {/* <DirectionLink direction="down" text="see more" link={extendLink} /> */}
InformationCard.propTypes = {
  title: PropTypes.string,
  content: PropTypes.array,
  accordionContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

export default InformationCard
